import React, {useEffect} from "react";
import FormTextField from "components/form/form-textfield";
import {injectIntl} from "react-intl";
import DataGrid, {DataGridItem} from "components/data-grid";
import FormChipInput from "components/form/form-chipinput";
import PropTypes from "prop-types";
import {RestrictedToAdmin} from "components/auth";
import FormAdminFields from "../../common-forms/restricted-admin-form";
import {PageHeaderBar, PageSection} from "components/page";
import FormCheckbox from "components/form/form-checkbox";
import {checkIfaDateIsLongerThanANumberOfHours} from "../../../../../utils/date";

const EditEventFinishedForm = ({customer, endDate, intl, isAuthorizedRecording, values, handleChange}) => {
    const handleChangeCheckboxTestEvent = (valueTest) => {
        handleChange("visible")(!valueTest);
        handleChange("billable")(!valueTest);
    }

    useEffect(() => {
        if (!!values.isInternalTest) {
            handleChangeCheckboxTestEvent(values.isInternalTest)
        }
    }, [values.isInternalTest])
    return (
        <>
            <RestrictedToAdmin>
                <DataGrid>
                    <DataGridItem>
                        <FormCheckbox
                            id="isInternalTest"
                            name="isInternalTest"
                            value="isInternalTest"
                            checked={values.isInternalTest}
                            onChange={handleChange}
                            label={intl.formatMessage({id: "event.isInternalTest"})}

                        />
                    </DataGridItem>
                    <DataGridItem>
                        <FormCheckbox
                            id="visible"
                            name="visible"
                            value="visible"
                            checked={values.visible}
                            onChange={handleChange}
                            label={intl.formatMessage({id: "event.visible"})}
                        />
                    </DataGridItem>
                    <DataGridItem>
                        <FormCheckbox
                            id="billable"
                            name="billable"
                            value="billable"
                            checked={values.billable}
                            onChange={handleChange}
                            label={intl.formatMessage({id: "event.billable"})}
                        />
                    </DataGridItem>
                </DataGrid>
            </RestrictedToAdmin>

            <PageHeaderBar subtitle title="app.page.event.form.basicData"/>
            <PageSection spaced>
                <DataGrid>
                    <DataGridItem big>
                        <FormTextField
                            type="text"
                            id="title"
                            name="title"
                            value={values.title}
                            onChange={handleChange}
                            label={intl.formatMessage({id: "common.title"})}
                        />
                    </DataGridItem>
                    <DataGridItem big>
                        <FormTextField
                            type="text"
                            id="description"
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            label={intl.formatMessage({id: "common.description"})}
                        />
                    </DataGridItem>
                    <DataGridItem big>
                        <FormChipInput
                            id="keywords"
                            name="keywords"
                            label={intl.formatMessage({id: "event.keywords"})}
                            onChange={handleChange}
                            defaultValue={values.keywords}
                            helperText={intl.formatMessage({id: "field.multipleSelect.help"})}
                        />
                    </DataGridItem>
                </DataGrid>
                {!!values?.localRecInfo && !checkIfaDateIsLongerThanANumberOfHours(endDate, 24) && isAuthorizedRecording &&
                    <DataGridItem>
                        <FormCheckbox
                            id="authorizedRecording"
                            name="authorizedRecording"
                            value="authorizedRecording"
                            checked={values.authorizedRecording}
                            onChange={handleChange}
                            label={intl.formatMessage({id: "event.authorizedRecording"})}
                        />
                    </DataGridItem>
                }
            </PageSection>
            <FormAdminFields values={values} handleChange={handleChange}/>
        </>
    )
};

EditEventFinishedForm.propTypes = {
    /**
     * Valores del formulario
     */
    values: PropTypes.object,
    /**
     * Callback que se dispara con el cambio del input
     */
    handleChange: PropTypes.func,
};

export default injectIntl(EditEventFinishedForm);
